import {
  CREATE_OFFER_FAILURE,
  CREATE_OFFER_REQUEST,
  GET_ALL_PRODUCT_OFFER_REQUEST,
  GET_ALL_PRODUCT_OFFER_SUCCESS,
  GET_ALL_PRODUCT_OFFER_FAILURE,
  DELETE_OFFER_REQUEST,
  DELETE_OFFER_FAILURE,
  UPDATE_OFFER_REQUEST,
  UPDATE_OFFER_FAILURE,
  CREATE_OFFER_SUCCESS,
  UPDATE_OFFER_SUCCESS,
  DELETE_OFFER_SUCCESS,
} from "./ActionType";

const initialState = {
  offers: [],
  offer: null,
  loading: false,
  error: "",
};

export const vendorProductOfferReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_OFFER_REQUEST:
      return { ...state, loading: true };

    case CREATE_OFFER_SUCCESS:
      return { ...state, loading: false, error: "", offer: action.payload };

    case CREATE_OFFER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_PRODUCT_OFFER_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PRODUCT_OFFER_SUCCESS:
      return { ...state, loading: false, error: "", offers: action.payload };

    case GET_ALL_PRODUCT_OFFER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_OFFER_REQUEST:
      return { ...state, loading: true };

    case DELETE_OFFER_SUCCESS:
      return { ...state, loading: false, error: "", offer: action.payload };

    case DELETE_OFFER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_OFFER_REQUEST:
      return { ...state, loading: true };

    case UPDATE_OFFER_SUCCESS:
      return { ...state, loading: false, error: "", offer: action.payload };

    case UPDATE_OFFER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
